module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABABAMAAABYR2ztAAAAHlBMVEUAAAC0tLS0tLS2trazs7O0tLS/v7+0tLS2trazs7PD01c4AAAACXRSTlMAVao5ynoMjhyxMBwqAAAAiklEQVRIx2MYWoAtSAkOVBOwKGCZiQQcsCiwRFYwGYsCSWQFE8lUAHMjTgUw5iBUwDQTJ1AYNAqYBQUrZ84URAMzZ04XFDTA4kVUrw5LBUpKygwMRkpKWBVABcHsUQUjQoGgoAQDQ6Og4KBOtDRWoIQG0BVgANIUICoTXJUKCzYFDlgrNJSKbcgAABwlUPFZaH5pAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/icon-delete.png
// module id = gCHg
// module chunks = 1